export default "__VITE_ASSET__CKpV4M7F__ 640w, __VITE_ASSET__BI73lR$___ 1024w";